import React from 'react';
import { getQuickActions } from './engine';
import { useOnboardingAgent } from './OnboardingAgentProvider';
import * as s from './style';

const OnboardingAgentRail = () => {
  const {
    open,
    setOpen,
    messages,
    draft,
    setDraft,
    sendText,
    triggerQuickAction,
    step,
    stepMeta,
  } = useOnboardingAgent();

  const quickActions = getQuickActions(step);

  if (!open) {
    return (
      <s.LaunchButton
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open onboarding guide"
      >
        Setup guide
      </s.LaunchButton>
    );
  }

  return (
    <s.Rail aria-label="GitDone onboarding guide">
      <s.RailHeader>
        <div>
          <s.RailTitle>Setup guide</s.RailTitle>
          <s.RailSubtitle>{stepMeta.title}</s.RailSubtitle>
        </div>
        <s.CloseButton type="button" onClick={() => setOpen(false)} aria-label="Close">
          ×
        </s.CloseButton>
      </s.RailHeader>

      {stepMeta.checklist?.length > 0 && (
        <s.Checklist>
          {stepMeta.checklist.map((item, index) => {
            let marker = '○ ';
            if (index < stepMeta.checklistIndex) {
              marker = '✓ ';
            } else if (index === stepMeta.checklistIndex) {
              marker = '→ ';
            }
            return (
              <s.ChecklistItem
                key={item}
                done={index < stepMeta.checklistIndex}
                active={index === stepMeta.checklistIndex}
              >
                {marker}
                {item}
              </s.ChecklistItem>
            );
          })}
        </s.Checklist>
      )}

      <s.Messages>
        {messages.map((message) => (
          <s.Bubble key={message.id} role={message.role}>
            {message.text}
          </s.Bubble>
        ))}
      </s.Messages>

      <s.QuickActions>
        {quickActions.map((action) => (
          <s.Chip
            key={action.id}
            type="button"
            onClick={() => triggerQuickAction(action.id)}
          >
            {action.label}
          </s.Chip>
        ))}
      </s.QuickActions>

      <s.Composer
        onSubmit={(event) => {
          event.preventDefault();
          sendText(draft);
        }}
      >
        <s.Input
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          placeholder="Ask about setup…"
          aria-label="Message the setup guide"
        />
        <s.SendButton type="submit" disabled={!draft.trim()}>
          Send
        </s.SendButton>
      </s.Composer>
    </s.Rail>
  );
};

export default OnboardingAgentRail;
